// import { motion } from "framer-motion";
// import { pageTransition } from "~/styleguide/motion";

const PageTransition = props => {
    return <div style={{ margin: 0 }}>{props.children}</div>;
};

export default PageTransition;
